import { CONFIG } from '../config.js';

/** @param {...unknown} args */
export function debugLog(...args) {
  if (CONFIG.debug?.verboseLogging) {
    console.info(...args);
  }
}

/** @returns {boolean} */
export function isPerfHudEnabled() {
  return Boolean(
    CONFIG.debug?.perfHud ?? CONFIG.performance?.debugHud,
  );
}

/** @returns {boolean} */
export function isDevGlobalEnabled() {
  if (CONFIG.debug?.exposeDevGlobal) return true;
  return typeof import.meta !== 'undefined' && Boolean(import.meta.env?.DEV);
}
